module.exports = __webpack_public_path__ + "static/media/DMSerifDisplay-Regular.359da220.ttf";